// src/components/pages/FinalPage.jsx
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";

import { Stack, Typography } from "@mui/material";

import HeaderBarcode from "../../shared/HeaderBarcode/HeaderBarcode";
import FinalPopup from "../../UI/FinalPopup/FinalPopup";

import {
  rewardCall,
  finalizeCall,
} from "../../../api/ExitApis/initiateExitApi";

import { getResumeToken } from "../GameFinishP2/GameFinishP2";
import bg from "../../../assets/images/map-bg-dstl-upd-11.webp";

import usePreloadAssets from "../../../hooks/usePreloadAssets";

import "./FinalPage.scss";

const Assets = [bg];

const FinalPage = () => {
  const { systemName, authToken } = useSelector(
    (state) => state.createUser.user
  );
  const exitState = useSelector((s) => s.exitFlow?.state);
  const [tire, setTier] = useState(null);
  const [message, setMessage] = useState("Thank you for joining WTUFO...");
  const [open, setOpen] = useState(false);
  // cta: { label: "Proceed", hrf: "/some-path" }
  const [cta, setCta] = useState({
    label: "",
    hrf: "",
  });

  usePreloadAssets(Assets);
  useEffect(() => {
    if (exitState === "finalized") {
      handleProceed();
      setOpen(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exitState]);

  const handleProceed = async () => {
    try {
      const response = await finalizeCall(
        systemName,
        authToken,
        getResumeToken()
      );

      if (response?.finalMessage) {
        setMessage(response.finalMessage);
        setOpen(true);
      }
    } catch (error) {}
  };

  useEffect(() => {
    const handleGetReward = async () => {
      // Placeholder for any finalization logic if needed

      try {
        const response = await rewardCall(
          systemName,
          authToken,
          getResumeToken()
        );

        if (response?.tier) {
          setTier(response.tier);
        }
        if (response?.cta) {
          setCta(response.cta);
        }
      } catch (error) {}
    };

    handleGetReward();

    return () => {
      // Cleanup if necessary
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="game-end-container">
      <Stack className="dotted-background">
        <Stack direction={"column"} className="container header">
          <HeaderBarcode />
        </Stack>

        <Stack className="container content" spacing={3}>
          <Stack
            className="notice-board board-final"
            spacing={5}
            justifyContent={"space-between"}
          >
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              spacing={6}
              pt={10}
            >
              <Typography variant="h1" className="final-title">
                🎉 Congratulations!
              </Typography>

              <Typography variant="body1">
                You’ve completed the mission. Press the button below to confirm
                you seat.
              </Typography>
              <Typography variant="h1" className="final-message">
                {tire && `You have earned the ${tire} tier reward!`}
              </Typography>
            </Stack>
            <Link
              variant="contained"
              //   color="primary"
              size="large"
              onClick={handleProceed}
              className="btn btn-flat"
              to={cta?.hrf}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              {cta?.label || "Proceed"}
            </Link>
          </Stack>
        </Stack>
        <FinalPopup open={open} message={message} />
      </Stack>
    </div>
  );
};

export default FinalPage;
